import axios, {Axios} from 'axios';
import {useAppSelector} from '@hooks/app';
import {useMemo} from 'react';
import {devBaseUrl, prodBaseUrl} from '../api';

export const useAuthAxios = (): Axios => {
  const {token, token_type} = useAppSelector(state => state.app.token || {token: '', token_type: ''});

  return useMemo(() => axios
    .create({
      baseURL: process.env.NODE_ENV === 'development' ? devBaseUrl : prodBaseUrl,
      headers: {
        Accept: 'application/json',
        ...(token ? {Authorization: `${token_type} ${token}`} : {}),
      },
    }), [token, token_type]);
};